function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m268.152344 316.210938c16.832031-.105469 30.421875-13.78125 30.421875-30.617188v-160.417969c0-35.238281 28.648437-63.902343 63.859375-63.902343 35.214844 0 63.859375 28.664062 63.859375 63.902343v74.921875c0 11.355469 9.207031 20.5625 20.5625 20.5625h20.109375c11.351562 0 20.558594-9.207031 20.558594-20.5625v-7.046875l-14.039063-16.976562 14.039063-27.671875v-23.3125c0-69.085938-56.003907-125.089844-125.089844-125.089844-69.082032 0-125.085938 56.003906-125.085938 125.089844v160.503906c0 16.984375 13.820313 30.71875 30.804688 30.617188zm0 0",
  fill: "#bec3d2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m322.210938 512h-281.988282c-22.214844 0-40.222656-18.007812-40.222656-40.222656v-235.679688c0-22.214844 18.007812-40.222656 40.222656-40.222656h281.988282c22.214843 0 40.222656 18.007812 40.222656 40.222656v235.679688c0 22.214844-18.007813 40.222656-40.222656 40.222656zm0 0",
  fill: "#FFC107"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m41.410156 195.875c-22.871094 0-41.410156 18.539062-41.410156 41.40625v233.308594c0 22.871094 18.539062 41.410156 41.410156 41.410156h139.808594v-316.125zm0 0",
  fill: "#FFC107"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m223.425781 316.261719c0-23.730469-19.582031-42.886719-43.46875-42.191407-21.769531.636719-39.730469 18.144532-40.886719 39.890626-.734374 13.828124 5.199219 26.296874 14.867188 34.496093l-8.355469 64.890625c-1.035156 8.023438 5.214844 15.125 13.304688 15.125h44.664062c8.089844 0 14.335938-7.101562 13.304688-15.125l-8.355469-64.890625c9.128906-7.742187 14.925781-19.289062 14.925781-32.195312zm0 0",
  fill: "#2b608e"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m179.957031 274.070312c-21.769531.636719-39.730469 18.144532-40.886719 39.886719-.734374 13.832031 5.199219 26.300781 14.867188 34.5l-8.355469 64.890625c-1.035156 8.019532 5.214844 15.125 13.300781 15.125h22.335938v-154.40625c-.421875 0-.839844-.007812-1.261719.003906zm0 0",
  fill: "#2b76ae"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2, _ref3, _ref4, _ref5);

export default __webpack_public_path__ + "static/media/unlocked.4532afca.svg";
export { SvgComponent as ReactComponent };